module.exports = __webpack_public_path__ + "static/media/team-emily.70d09b4c.png";